import { MissionsManagerStateInterface, VehicleInterface } from "./interfaces";

const initialVehicleState: VehicleInterface = {
  in_point: {
    coordinates: [],
    type: "Point"
  },
  out_point: {
    coordinates: [],
    type: "Point"
  },
  awaiting_point: undefined
};

export const initialState: MissionsManagerStateInterface = {
  missions: [],
  mission: undefined,
  vehicles: [],
  vehicle: initialVehicleState,
  isFetchMissionsLoading: false,
  isDeleteMissionLoading: false,
  isFetchMissionLoading: false,
  isCreateMissionLoading: false,
  isFetchVehiclesLoading: false,
  isCreateVehicleLoading: false,
  isUpdateVehicleLoading: false,
  isDeleteVehicleLoading: false,
  isRunRouteAnalysisLoading: false
};
